module.exports = "/fonts/nucleo-icons.eot?bd42d77b9672555647d129de2af06f15";